import { useQuery, useMutation } from '@tanstack/react-query';
import {
  getCompanyInfo,
  updateCompanyInfo,
  createCompany,
  transferCompanyMember,
  getCouponList,
  activateCompanyCoupon,
  importCompany,
  importPoint,
} from '../api/company';

export const useGetCompany = ({ enabled, ...params }) => {
  return useQuery({
    queryKey: ['company-list', params],
    queryFn: ({ signal }) => getCompanyInfo(params, signal),
    enabled,
  });
};

export const useUpdateCompany = () => {
  return useMutation({
    mutationFn: ({ params, dto, signal }) => updateCompanyInfo(params, dto, signal),
  });
};

export const useCreateCompany = () => {
  return useMutation({
    mutationFn: (dto) => createCompany(dto),
  });
};

export const useTransferCompanyMember = () => {
  return useMutation({
    mutationFn: ({ dto, signal }) => transferCompanyMember(dto, signal),
  });
};

export const useGetCouponList = ({ enabled, ...params }) => {
  return useQuery({
    queryKey: ['coupon-list', params],
    queryFn: ({ signal }) => getCouponList(params, signal),
    enabled,
  });
};

export const useActivateCompanyCoupon = () => {
  return useMutation({
    mutationFn: (dto) => activateCompanyCoupon(dto),
  });
};

export const useImportCompany = () => {
  return useMutation({
    mutationFn: ({ params, payload }) => importCompany(params, payload),
  });
};

export const useImportPointCompany = () => {
  return useMutation({
    mutationFn: ({ params, payload }) => importPoint(params, payload),
  });
};
